import PlanosComponent from "../../components/PlanosComponent";

function Planos() {
    return (
        <PlanosComponent />
    );
}

export default Planos;